import {
  createAuthorFilter,
  createLikesFilter,
  createModerationLabelFilter,
  createProductAreaFilter,
  createPublicTagFilter,
  createStatusFilter
} from './Filters'
import {
  createAuthorColumn,
  createLikesColumn,
  createProductAreasColumn,
  createPublicTagsColumn,
  createPublishDateColumn,
  createStatusColumn,
  createTitleColumn
} from './Columns'
import { ModerationLabel } from './types'
import { ChangeAuthor } from './BulkActions'
/* eslint-disable import/no-internal-modules */
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import globals, { ModulesContext } from '@insided/deprecated-utils/globals'
import { common } from '@insided/deprecated-preact-components/common'
import { Module } from '@insided/deprecated-services/modules'
import Overview from '@insided/deprecated-control/overview'

interface Props {
  moderationLabels: ModerationLabel[]
  allProductAreas: []
}

const ProductUpdateOverview = ({ moderationLabels, allProductAreas }: Props) => {
  function getFilters() {
    const filters = [
      createStatusFilter(true),
      createProductAreaFilter(true),
      createModerationLabelFilter(moderationLabels),
      createAuthorFilter(),
      createPublicTagFilter(),
      createLikesFilter()
    ]
    if (!common.isModuleActive('productAreas')) {
      filters.splice(0, 1) // remove Product areas column if module is disabled
    }
    return filters
  }

  function getColumns() {
    const columns = [
      createTitleColumn(),
      createProductAreasColumn(allProductAreas),
      createStatusColumn(),
      createLikesColumn(),
      createPublishDateColumn(),
      createAuthorColumn(),
      createPublicTagsColumn(true)
    ]
    if (!common.isModuleActive('productAreas')) {
      columns.splice(1, 1) // remove Product areas column if module is disabled
    }
    return columns
  }

  function getBulkActions(modules: Module[]) {
    if (modules.includes('changeAuthorOfPublishedContent')) {
      return [ChangeAuthor]
    }

    return []
  }

  return (
    <ModulesContext.Consumer>
      {(modules) => {
        return (
          <Overview
            type='product-update'
            headerTitle='Product Updates'
            withPagination={{
              page: 1,
              pageSize: 25
            }}
            withSorting={{
              lastEditedAt: 'desc'
            }}
            withFilters={getFilters()}
            bulkActions={getBulkActions(modules)}
            withSearch
            searchPlaceholder='Search in title and content'
            withColumns
            rowId='id'
            model={getColumns()}
            endpoint='/product-update/overview/topics'
            dataKey='topics'
            EmptyStateComponent={
              <EmptyPage
                img_src={`${globals('defaultCdn') as string}/images/empty_page.png`}
                header='No product update found'
                text='Seems like no one on your team has created any product update. Start now by creating a new product update.'
                button={{ link: '/content/new/product_update', text: 'New product update' }}
              />
            }
          />
        )
      }}
    </ModulesContext.Consumer>
  )
}

export default ProductUpdateOverview
